var _ = require('lodash');
var jQuery = require('jquery');
var ubBanzai = require('ub/control/banzai-features');

var _addMissingAttrs = function(page) {
  // This is to set default values to properties that might not exist in older poms.
  if (page.page && page.page.used_as === 'main') {
    page.settings.mobilePage = page.settings.mobilePage || false;
    page.settings.noRobots = page.settings.noRobots || false;
  }

  // It appears this needs to always be set to "PageVariant". Any other value can break saving to webapp
  page.type = 'PageVariant';

  page.settings.multipleBreakpointsVisibility =
    page.settings.multipleBreakpointsVisibility || false;
};

var _mergePageData = function(currentPageData, storedPageData) {
  _addMissingAttrs(storedPageData);

  var newPageData = jQuery.extend(false, {}, currentPageData, storedPageData);

  newPageData.elements = storedPageData.elements;
  newPageData.settings = jQuery.extend(true, {}, currentPageData.settings, storedPageData.settings);
  newPageData.page = jQuery.extend(true, {}, storedPageData.page, currentPageData.page);

  return newPageData;
};

var _filterAndMergeSubPageData = function(newPomSubPages, storedSubPages) {
  return _.map(
    storedSubPages,
    function(storedSubPage) {
      var commonExistingPage = _.find(newPomSubPages, function(newPomSubPage) {
        return newPomSubPage.id === storedSubPage.id;
      });

      // If this is an existing subpage, merge the old page data with the stored data.
      // Otherwise just return the stored pom data.
      if (commonExistingPage) {
        return _mergePageData(commonExistingPage, storedSubPage);
      } else {
        return storedSubPage;
      }
    }
  );
};

var _addCompanyData = function(pomData, editor) {
  pomData.unbounce_company_id = editor.unbounceCompanyId;
  pomData.unbounce_assets_company_id = editor.unbounceAssetsCompanyId;
  pomData.current_company_id = editor.currentCompanyId;
};

var _upgradePageAttrs = function(page) {
  // We don't have to worry about the types in page.elements and page.settings
  // as their data was stored differently and successfully retain their original types.

  page.id = parseInt(page.id, 10);
  page.last_element_id = parseInt(page.last_element_id, 10);
  page.page.id = parseInt(page.page.id, 10);

  page.has_form = Boolean(page.has_form);

  page.keywords = String(page.keywords);
  page.name = String(page.name);
  page.description = String(page.description);
  page.title = String(page.title);
  page.version = String(page.version);
  page.type = String(page.type);
};

var _buildNewPomForRestore = function(currentPomData, storedPom, editor) {
  var newPom = _.clone(currentPomData);

  _addCompanyData(newPom, editor);

  if (!storedPom.mainPage || !storedPom.mainPage.elements) {
    return newPom;
  }

  newPom.mainPage = _mergePageData(newPom.mainPage, storedPom.mainPage);
  newPom.subPages = _filterAndMergeSubPageData(newPom.subPages, storedPom.subPages);

  // Older pomsaves had their number/boolean values converted to strings.
  // This is here to coerce those values back to the proper type.
  _upgradePageAttrs(newPom.mainPage);

  _.each(
    newPom.subPages,
    function(subPage) {
      _upgradePageAttrs(subPage);
    },
    this
  );

  if (ubBanzai.features.isDebugModeEnabled()) {
    console.log(
      'Restoring page from backup',
      'Original Pom: ',
      currentPomData,
      'Stored Pom ',
      storedPom,
      'Merged Pom: ',
      newPom
    );
  }

  return newPom;
};

module.exports = {
  buildNewPomForRestore: _buildNewPomForRestore,
};



// WEBPACK FOOTER //
// ./src/ui/pom-merger.js